import React from 'react';
import InfoNotification from '@src/components/Notifications/InfoNotification';
import {ServerNotificationProps} from '@src/components/Notifications/server-notifications/ServerNotification';
import {INotificationProps} from '@src/@interfaces/components/Notifications/INotificationProps';
import app from '@src/helpers/app';
import getUri from '@src/helpers/getUri';
import CommentInline from '@src/components/CommentsList/CommentInline';
import {getProductionDashboardUrlIfPossible} from './getProductionDashboardUrlIfPossible';
import {
    getManagerDashboardProductsListSearchParams
} from '@src/components/Notifications/server-notifications/Order/Product/getManagerDashboardProductsListSearchParams';
import makeUrl from '@src/components/Notifications/server-notifications/makeUrl';
import {
    getSearchTermParams
} from '@src/components/Notifications/server-notifications/Order/Product/getSearchTermParams';

export default class CommentAdded extends InfoNotification<
        ServerNotificationProps<'App\\Notifications\\Order\\Product\\CommentAdded'> &
        INotificationProps
> {
    protected getWrapperTagProps(): any {
        const payload = this.props.notification.data;
        const namesResolver = app('names-resolver').clientRoutes;

        const getSearchParams = (params: Record<string, string>) => {
            return getSearchTermParams('OrderProducts', String(payload.orderId), params);
        };

        let toUrl = getProductionDashboardUrlIfPossible(payload.orderProductId);
        if (!toUrl) {
            toUrl = getUri({
                route: namesResolver.getShowRouteName('Orders'),
                params: {
                    id: String(payload.orderId),
                },
            });
        }

        const searchParams = getSearchParams(
                getManagerDashboardProductsListSearchParams({
                    productId: String(payload.orderProductId),
                    commentId: String(payload.comment.id),
                })
        );

        return {
            ...super.getWrapperTagProps(),
            to: makeUrl({url: toUrl, searchParams, hash: '#OrdersShow.tabs.products'}),
        };
    }

    protected renderMessage() {
        return <CommentInline
                model={this.props.notification.data.comment}
                allowToDelete={false}
                allowToReply={false}
                allowHighlight={false}
        />;
    }
}
